import React from "react";

// Rendered in place of a field's real value when the logged-in user's
// Display-role has that field turned off. The label stays visible (the
// caller renders that separately) — only the value itself is masked,
// the field is never fully hidden.
const MaskedValue = ({ height = 34 }) => (
  <div
    style={{
      height,
      display: "flex",
      alignItems: "center",
      padding: "0 10px",
      background: "#f1f5f9",
      border: "1px solid #e2e8f0",
      borderRadius: 4,
      color: "transparent",
      textShadow: "0 0 8px rgba(51,65,85,0.65)",
      userSelect: "none",
      fontSize: 13,
      letterSpacing: 2
    }}
  >
    ████████
  </div>
);

export default MaskedValue;